import { loggedIn } from '../../../routes/conditional';
import {
  clearAddItemError,
  searchCCPharmacy,
  setDeliveryAddressOrderId,
} from '../../../redux/modules/orders';
import { getPendingOrdersDeliveryAddressOrderId } from '../../../redux/modules/root-reducer';
import paths from '../../../routes/paths';
import { selectedCCPharmacy } from '../../../redux/modules/neworder';

export const page = {
  path: paths.createOrder.ccSelectPharmacy,
  isAllowed: [loggedIn],
  action: ({ state }) =>
    setDeliveryAddressOrderId(getPendingOrdersDeliveryAddressOrderId(state)),
};

export const searchCCLocation = {
  actionPath: '/actions/create-order/search-cclocation',
  searchinputName: 'ccStoreName',
  cclocationInput: 'ccStoreID',
  action: ({ body }) => searchCCPharmacy(body?.ccStoreName),
};

export const selectCCLocation = {
  actionPath: '/actions/create-order/select-ccstore-location',
  inputName: 'ccStoreDetails',
  mapccStoreInputValue: (m) => JSON.stringify(m),
  action: ({ body }) => {
    let pharmacy;
    try {
      pharmacy = JSON.parse(body.ccStoreDetails);
    } catch (error) {
      console.log(error);
    }
    return selectedCCPharmacy(pharmacy);
  },
};

export const clearSelectionError = {
  actionPath: '/actions/create-order/clear-ccstore-location-error',
  action: () => clearAddItemError(),
};
